import { createContext, useContext, useState } from 'react';

const MessageModalContext = createContext(null);

export function MessageModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    return (
        <MessageModalContext.Provider value={{ isOpen, openModal, closeModal }}>
            {children}
        </MessageModalContext.Provider>
    );
}

export function useMessageModal() {
    const ctx = useContext(MessageModalContext);
    if (!ctx) throw new Error('useMessageModal must be used within MessageModalProvider');
    return ctx;
}
